import Link from 'next/link'
import type { ReactElement } from 'react'
import styled from 'styled-components'

import { PxToVw } from '@/utils/convertPx'
import { LEGAL_ROUTE } from '@/utils/routes'

import { Button } from '@/components/elements/Button'
import { ImageTitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

export const LegalPage = () => {
  return (
    <LegalMain>
      <LegalLinks>
        {LEGAL_ROUTE.subdirectories.map(({ name, path }) => (
          <Link href={path} passHref key={name}>
            <a>
              <Button btnStyle="normal">{name}</Button>
            </a>
          </Link>
        ))}
      </LegalLinks>
    </LegalMain>
  )
}

LegalPage.getLayout = function getLayout(page: ReactElement) {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '法務', path: '' },
  ]

  return (
    <>
      <Head
        title="法務"
        description="トライアルホールディングスの法務に関するコンテンツをご覧いただけます。"
        ogp={{ url: 'legal/' }}
      />
      <ImageTitleLayout
        title="Legal"
        subTitle="法務"
        imgUrl="/images/top-legal.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground={false}
      >
        {page}
      </ImageTitleLayout>
    </>
  )
}

const LegalMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 96px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    margin: 40px 20px 70px;
  }
`

const LegalLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 50px 43px;

  button {
    width: 318px;
  }

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    align-items: center;
    gap: 24px 0;

    button {
      width: ${PxToVw(314, 390)};
      max-width: 314px;
      height: 36px;
    }
  }
`
